"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmptyCheck = void 0;
const isEmptyCheck = (value) => {
    var _a;
    return (_a = [null, 'null', undefined, '']) === null || _a === void 0 ? void 0 : _a.includes(value);
};
exports.isEmptyCheck = isEmptyCheck;
